import $ from 'jquery';
import {is_function} from '../../../../Helpers/js';

$.initialize('[data-plugin~="textInputClearer"]', function () {
  $(this).textInputClearer();
});
$.fn.textInputClearer = function (callback, showAlways) {
  'use strict';

  showAlways = showAlways || false;
  this.each(function () {
    var $textfield = $(this),
      $textinput = $textfield.find('input'),
      $righticon = $('<i>').addClass('link icon icon-cancel-5 rightaligned');

    $righticon.hide().appendTo($textfield);

    if (showAlways) {
      $righticon.show();
    } else if ($textinput.val() !== '') {
      $righticon.show();
    } else {
      $righticon.hide();
    }

    $textinput.on('input', function () {
      if (showAlways) {
        $righticon.show();
      } else if ($textinput.val() !== '') {
        $righticon.show();
      } else {
        $righticon.hide();
      }
    });

    $righticon.on('click', function () {
      var removeText = true;
      if (is_function(callback)) {
        removeText = callback.call(this);
      }
      if (removeText) {
        $textinput.val('').trigger('change').trigger('input');
        !showAlways && $(this).hide();
      }
    });
  });
};
